import { render, staticRenderFns } from "./GridProductionTeam.vue?vue&type=template&id=f94f0928"
import script from "./GridProductionTeam.vue?vue&type=script&lang=js"
export * from "./GridProductionTeam.vue?vue&type=script&lang=js"
import style0 from "./GridProductionTeam.vue?vue&type=style&index=0&id=f94f0928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports